import { apiClient } from '@/lib/api-client';
import { EditionsApiDatasource } from '../data/datasources/editions-api.datasource';
import { EditionsRepositoryImpl } from '../data/repositories/editions.repository.impl';

const apiDatasource = new EditionsApiDatasource(apiClient);
const repository = new EditionsRepositoryImpl(apiDatasource);

export const editionsContainer = { repository };
